import { USER_LOGGED_IN_DETAILS, ADMIN_SIDEBAR_SCROLL_POSITION, ADMIN_ACTIVE_SIDEBAR_MENU, ACTIVEID } from "../types";

export const saveUserDetails = (payload) => {
  return {
    type: USER_LOGGED_IN_DETAILS,
    payload,
  };
};
export const setActiveId = (payload) => {
  return {
    type: ACTIVEID,
    payload,
  };
};
export const saveAdminSideBarScrollPosition = (payload) => {
  return {
    type: ADMIN_SIDEBAR_SCROLL_POSITION,
    payload,
  };
};
export const saveAdminActiveSidebarTab = (payload) => {
  return {
    type: ADMIN_ACTIVE_SIDEBAR_MENU,
    payload,
  };
};
